import { render } from "./Dropdown1.vue?vue&type=template&id=154e32f0&ts=true"
import script from "./Dropdown1.vue?vue&type=script&lang=ts"
export * from "./Dropdown1.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__